import { render, staticRenderFns } from "./panelNav.vue?vue&type=template&id=3ecd8e0c&scoped=true"
import script from "./panelNav.vue?vue&type=script&lang=js"
export * from "./panelNav.vue?vue&type=script&lang=js"
import style0 from "./panelNav.vue?vue&type=style&index=0&id=3ecd8e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecd8e0c",
  null
  
)

export default component.exports